import { render, staticRenderFns } from "./dataShowBox.vue?vue&type=template&id=0862f764&scoped=true"
import script from "./dataShowBox.vue?vue&type=script&lang=js"
export * from "./dataShowBox.vue?vue&type=script&lang=js"
import style0 from "./dataShowBox.vue?vue&type=style&index=0&id=0862f764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0862f764",
  null
  
)

export default component.exports